<template>
  <div class="relative" :class="{ 'p-0': $route.params.id }">
    <div
      v-if="$route.params.id"
      class="bank-details-container bg-white p-3 p-md-5 h-100"
    >
      <BanksListItemBack
        v-if="defaultBankInfo && defaultBankInfo.objectID"
        :info="defaultBankInfo"
        @close="hideDetails"
      />
    </div>
    <div v-if="isClient || !$route.params.id" v-show="!$route.params.id">
      <AisInfiniteHits :transform-items="transformItems">
        <div
        slot-scope="{ items, isLastPage, refine }"
        class="px-md-4 py-4 d-flex flex-wrap justify-content-center relative w-100"
        >
          <BanksListItem v-for="(bank, index) in items" :key="`bank-${index}`" :info="bank" @select="showDetails" />
          <div class="text-center w-100" v-if="!isLastPage">
            <a href="#" v-on:click.prevent="refine" class="mx-auto dashed-link text-white" :disabled="isLastPage"
            >Show more</a
            >
          </div>
          <AisStats v-else class="text-center w-100">
            <p slot-scope="{ nbHits }" class="text-center pt-4">
              <span v-if="nbHits" class="text-white">Count of banks: {{ nbHits }}</span>
              <span v-else>
                <img src="../../../assets/sad.svg" alt="not found" class="my-4" />
                <span class="d-block lead text-white">No banks found. Try to change search criteria</span>
              </span>
            </p>
          </AisStats>
        </div>
      </AisInfiniteHits>
    </div>
  </div>
</template>

<script>
import BanksListItem from './BanksListItem.vue'
import BanksListItemBack from './BanksListItemBack'
import algoliaInit from '../../../algolia'

export default {
  name: 'BanksList',
  data() {
    return {
      defaultBankInfo: {},
      isClient: false,
      savedScrollPosition: 0
    }
  },
  components: {
    BanksListItem,
    BanksListItemBack
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      if (!newId && oldId) {
        this.$nextTick(() => window.scrollTo(0, this.savedScrollPosition))
      }
    }
  },
  mounted() {
    this.isClient = (typeof window !== 'undefined') && !(window.navigator && window.navigator.webdriver)

    const paramId = this.$route.params.id
    if (paramId) {
      this.fetchBankData(paramId)
    }
  },
  methods: {
    transformItems(items) {
      return items.filter((item) => item.name)
    },
    async fetchBankData(id) {
      if (this.defaultBankInfo && this.defaultBankInfo.objectID === id) {
        return
      }
      const index = algoliaInit.initIndex('banks')
      try {
        const content = await index.getObjects([id, id.toUpperCase(), id.toLowerCase()])
        const result = content.results.find(r => r && r.objectID)
        if (result) {
          this.defaultBankInfo = result
        } else {
          this.hideDetails()
        }
      } catch {
        this.hideDetails()
      }
    },
    showDetails(bankData) {
      this.savedScrollPosition = window.scrollY
      this.defaultBankInfo = bankData
      this.$router.push({
        name: 'banks-item',
        params: { id: bankData.objectID }
      })
      this.$nextTick(() => window.scrollTo(0, 0))
    },
    hideDetails() {
      this.defaultBankInfo = {}
      this.$router.push({ name: 'banks' })
    }
  }
}
</script>

<style scoped>
@media (max-width: 992px) {
  .bank-details-container {
    position: fixed;
    top: 80px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    height: auto !important;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
}
</style>
